import { LayoutRoute, Route } from "@soft-db/typed-router";

export const integrityRoutes = new LayoutRoute({
	path: "integrity",
	name: "integrity",
	meta: {
		feature: "integrity",
	},
	component: () => import("@/pages/integrity/IntegrityLayout.vue"),
	children: [
		new Route({
			path: "",
			component: () => import("@/pages/integrity/GroupIntegrity.vue"),
		}),
		new Route({
			path: "stations/:id",
			component: () => import("@/pages/integrity/IntegrityPage.vue"),
			meta: { permission: "station.update" },
		}),
		new Route({
			path: "sites/:id",
			component: () => import("@/pages/integrity/IntegrityPage.vue"),
		}),
	],
});
